import { PROMOCODES_SESSIONS, PROMOCODES_VALIDATE } from '@gameday/common/constants/endpoints'

export default {
  validate: PROMOCODES_VALIDATE, // 'gamedayapi/promocodes/validate',
  sessions: PROMOCODES_SESSIONS, // 'gamedayapi/promocodes/sessions',
}
